import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, query, where, onSnapshot, updateDoc, doc, setDoc, deleteDoc, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { getDoc } from 'firebase/firestore';
import { auth } from '../../firebase';
import './ServerOrder.css';
import { 
  FaClipboardList, 
  FaSearch, 
  FaCheck, 
  FaTimes, 
  FaSpinner,
  FaClock,
  FaUser,
  FaTable,
  FaUtensils,
  FaShoppingCart,
  FaCheckCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaEdit,
  FaPlus,
  FaMinus,
  FaEuroSign,
  FaCommentAlt,
  FaBell,
  FaArrowUp,
  FaArrowDown
} from 'react-icons/fa';

const menuId = "ZifkqWN99oRgRNM0Nisz";

const ServerOrder = () => {
  const [initialisedCommandes, setInitialisedCommandes] = useState([]);
  const [acceptedCommandes, setAcceptedCommandes] = useState([]);
  const [completedCommandes, setCompletedCommandes] = useState([]);
  const [user, setUser] = useState(null);
  const [serverFirstName, setServerFirstName] = useState('');
  const [searchId, setSearchId] = useState('');
  const navigate = useNavigate();
  const [editingOrder, setEditingOrder] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingItems, setEditingItems] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [showAddItemForm, setShowAddItemForm] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedComment, setSelectedComment] = React.useState(null);
  const [loading] = useState(true);
  const [filterTable, setFilterTable] = useState('all');
  const [sortBy, setSortBy] = useState('time');
  const [sortOrder, setSortOrder] = useState('desc');
  const [showStats] = useState(true);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const cleanItemName = (name) => name.replace(/\s*\(.*?\)\s*/g, '').trim();

  useEffect(() => {
    const fetchServerInfo = async () => {
      if (user) {
        try {
          const serverRef = doc(db, 'identifications', user.uid);
          const serverSnap = await getDoc(serverRef);
  
          if (serverSnap.exists()) {
            setServerFirstName(serverSnap.data().firstName);
          } else {
            console.error("Aucune donnée pour ce serveur.");
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des informations du serveur :", error);
        }
      }
    };
  
    fetchServerInfo();
  }, [user]);
  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    const fetchCommandes = async () => {
      try {
        const clientsCollection = collection(db, 'clients');

        onSnapshot(clientsCollection, (clientsSnapshot) => {
            clientsSnapshot.forEach(async (clientDoc) => {
              const clientId = clientDoc.id;
              const clientData = clientDoc.data();
              const commandesCollection = collection(db, `clients/${clientId}/commande`);
          
              // Query pour récupérer les commandes "Initialisé"
              const qInitialised = query(commandesCollection, where('statut', '==', 'Initialisée'));
              // Query pour récupérer les commandes "Accepté"
              const qAccepted = query(commandesCollection, where('statut', '==', 'Accepté'));
              // Query pour récupérer les commandes "Terminé"
              const qCompleted = query(commandesCollection, where('statut', '==', 'Terminé'));
          
              // Écoute en temps réel des commandes "Initialisé"
              onSnapshot(qInitialised, (commandesSnapshot) => {
                let clientInitialisedOrders = [];
          
                commandesSnapshot.forEach((commandeDoc) => {
                  const commandeData = commandeDoc.data();
                  const elapsedTime = Math.floor((Date.now() - commandeData.date.toDate()) / 60000); // Calculer le temps écoulé en minutes
          
                  clientInitialisedOrders.push({
                    clientId,
                    commandeId: commandeDoc.id,
                    table: clientData.table, // Ajouter le numéro de table du client
                    idclient: clientData.idclient,
                    prenom: clientData.prenom, // Ajouter le prénom du client
                    email: clientData.email, // Ajouter l'email du client
                    elapsedTime,
                    ...commandeData,
                  });
                });
          
                setInitialisedCommandes((prevCommandes) => [
                  ...prevCommandes.filter((cmd) => cmd.clientId !== clientId),
                  ...clientInitialisedOrders,
                ]);
              });
          
              // Écoute en temps réel des commandes "Accepté"
              onSnapshot(qAccepted, (commandesSnapshot) => {
                let clientAcceptedOrders = [];
          
                commandesSnapshot.forEach((commandeDoc) => {
                  const commandeData = commandeDoc.data();
                  const elapsedTime = Math.floor((Date.now() - commandeData.date.toDate()) / 60000); // Calculer le temps écoulé en minutes
          
                  clientAcceptedOrders.push({
                    clientId,
                    commandeId: commandeDoc.id,
                    table: clientData.table, // Ajouter le numéro de table du client
                    idclient: clientData.idclient,
                    prenom: clientData.prenom, // Ajouter le prénom du client
                    email: clientData.email, // Ajouter l'email du client
                    elapsedTime,
                    ...commandeData,
                  });
                });
          
                setAcceptedCommandes((prevCommandes) => [
                  ...prevCommandes.filter((cmd) => cmd.clientId !== clientId),
                  ...clientAcceptedOrders,
                ]);
              });
          
              // Écoute en temps réel des commandes "Terminé"
              onSnapshot(qCompleted, (commandesSnapshot) => {
                let clientCompletedOrders = [];
          
                commandesSnapshot.forEach((commandeDoc) => {
                  const commandeData = commandeDoc.data();
                  const elapsedTime = Math.floor((Date.now() - commandeData.date.toDate()) / 60000); // Calculer le temps écoulé en minutes
                  
                  clientCompletedOrders.push({
                    clientId,
                    commandeId: commandeDoc.id,
                    table: clientData.table, // Ajouter le numéro de table du client
                    idclient: clientData.idclient,
                    prenom: clientData.prenom, // Ajouter le prénom du client
                    email: clientData.email, // Ajouter l'email du client
                    elapsedTime,
                    ...commandeData,
                  });
                });
          
                setCompletedCommandes((prevCommandes) => [
                  ...prevCommandes.filter((cmd) => cmd.clientId !== clientId),
                  ...clientCompletedOrders,
                ]);
              });
            });
          });          
      } catch (error) {
        console.error("Erreur lors de la récupération des commandes: ", error);
      }
    };

    fetchCommandes();
  }, []);

  // Gérer l'acceptation de la commande
  const handleAcceptOrder = async (clientId, commandeId, clientPrenom, clientEmail) => {
    try {
      // Validation et nettoyage des IDs
      if (!clientId || !commandeId) {
        throw new Error('ID client ou commande manquant');
      }
      
      // Nettoyer les IDs pour éviter les caractères spéciaux
      const cleanClientId = clientId.toString().trim();
      const cleanCommandeId = commandeId.toString().trim();
      
      console.log('Accepting order:', { cleanClientId, cleanCommandeId });
      
      const commandeRef = doc(db, `clients/${cleanClientId}/commande`, cleanCommandeId);
      const now = new Date(); // Obtenir l'heure actuelle
  
      await updateDoc(commandeRef, {
        statut: 'Accepté',
        date: now, // Mettre à jour la date de l'acceptation
        serverName: serverFirstName, // Ajouter le nom du serveur qui accepte
      });

      const clientRef = doc(db, `clients/${cleanClientId}`);
      await updateDoc(clientRef, {
        serverName: serverFirstName // Ajouter le nom du serveur au niveau du client
      });
  
      // Mettre à jour l'état local après avoir accepté une commande
      setInitialisedCommandes((prevCommandes) =>
        prevCommandes.filter((commande) => commande.commandeId !== commandeId)
      );
      
      showMessage('Commande acceptée avec succès', 'success');
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la commande: ", error);
      showMessage('Erreur lors de l\'acceptation de la commande', 'error');
    }
  };

  // Gérer la finalisation de la commande et l'envoi dans "total_commande"
  const handleCompleteOrder = async (clientId, commandeId, commandeItems, clientPrenom, clientIdClient) => {
    try {
      // Validation et nettoyage des IDs
      if (!clientId || !commandeId) {
        throw new Error('ID client ou commande manquant');
      }
      
      const cleanClientId = clientId.toString().trim();
      const cleanCommandeId = commandeId.toString().trim();
      
      const commandeRef = doc(db, `clients/${cleanClientId}/commande`, cleanCommandeId);
      const now = new Date(); // Obtenir l'heure actuelle
      await updateDoc(commandeRef, { statut: 'Terminé', date: now, serverName: serverFirstName}); // Mettre à jour le statut et la date

      // Calculer le total de la commande
      const totalAmount = commandeItems.reduce((acc, item) => acc + item.prix * item.quantity, 0);

      const cleanedItems = commandeItems.map(item => ({
        ...item,
        nom: cleanItemName(item.nom) // Nettoie le nom de l'article
      }));
  
      // Ajouter le prénom et idclient dans la collection "total_commande"
      const totalCommandeRef = doc(db, 'total_commande', cleanCommandeId);
      await setDoc(totalCommandeRef, {
        commandeId: commandeId,
        items: cleanedItems, // Utilisation des articles nettoyés
        total: totalAmount,
        date: now, // Inclure la date de finalisation de la commande
        prenom: clientPrenom, // Ajouter le prénom du client
        idclient: clientIdClient, // Ajouter l'idclient du client
      });
  
      // Mettre à jour l'état local après avoir terminé une commande
      setAcceptedCommandes((prevCommandes) => prevCommandes.filter(commande => commande.commandeId !== commandeId));
      showMessage('Commande terminée avec succès', 'success');
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la commande: ", error);
      showMessage('Erreur lors de la finalisation de la commande', 'error');
    }
  };  

  // Gérer le changement de statut de la commande en "Commande servi"
  const handleServeOrder = async (clientId, commandeId) => {
    try {
      // Validation et nettoyage des IDs
      if (!clientId || !commandeId) {
        throw new Error('ID client ou commande manquant');
      }
      
      const cleanClientId = clientId.toString().trim();
      const cleanCommandeId = commandeId.toString().trim();
      
      const commandeRef = doc(db, `clients/${cleanClientId}/commande`, cleanCommandeId);
      const now = new Date(); // Obtenir l'heure actuelle
      await updateDoc(commandeRef, { statut: 'Commande servi', date: now, serverName: serverFirstName}); // Mettre à jour le statut et la date et le nom

      // Mettre à jour l'état local après avoir servi une commande
      setCompletedCommandes((prevCommandes) => prevCommandes.filter(commande => commande.commandeId !== commandeId));
      showMessage('Commande servie avec succès', 'success');
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut de la commande: ", error);
      showMessage('Erreur lors du marquage comme servi', 'error');
    }
  };

  // Fonction pour mettre à jour le timer toutes les minutes
  useEffect(() => {
    const interval = setInterval(() => {
      setInitialisedCommandes((prevCommandes) =>
        prevCommandes.map((commande) => ({
          ...commande,
          elapsedTime: Math.floor((Date.now() - commande.date.toDate()) / 60000), // Mettre à jour le temps écoulé
        }))
      );
      setAcceptedCommandes((prevCommandes) =>
        prevCommandes.map((commande) => ({
          ...commande,
          elapsedTime: Math.floor((Date.now() - commande.date.toDate()) / 60000), // Mettre à jour le temps écoulé
        }))
      );
      setCompletedCommandes((prevCommandes) =>
        prevCommandes.map((commande) => ({
          ...commande,
          elapsedTime: Math.floor((Date.now() - commande.date.toDate()) / 60000), // Mettre à jour le temps écoulé
        }))
      );
    }, 60000); // Mettre à jour toutes les minutes

    return () => clearInterval(interval); // Nettoyer l'intervalle à la désinstallation
  }, []);

  // Fonction pour afficher un message
  const showMessage = (text, type) => {
    setMessage(text);
    setMessageType(type);
    setTimeout(() => {
      setMessage('');
      setMessageType('');
    }, 5000);
  };

  // Calculer les statistiques
  const calculateStats = () => {
    const totalOrders = initialisedCommandes.length + acceptedCommandes.length + completedCommandes.length;
    const pendingOrders = initialisedCommandes.length;
    const inProgressOrders = acceptedCommandes.length;
    const readyOrders = completedCommandes.length;
    const urgentOrders = initialisedCommandes.filter(cmd => cmd.elapsedTime >= 10).length;
    
    return {
      totalOrders,
      pendingOrders,
      inProgressOrders,
      readyOrders,
      urgentOrders
    };
  };

  const filterCommandes = (commandes) => {
    let filtered = commandes;
    
    // Filtrer par recherche d'ID
    if (searchId) {
      filtered = filtered.filter((commande) => 
        commande.idclient?.toString().includes(searchId) ||
        commande.prenom?.toLowerCase().includes(searchId.toLowerCase())
      );
    }
    
    // Filtrer par table
    if (filterTable !== 'all') {
      if (filterTable === 'a_emporter') {
        filtered = filtered.filter((commande) => commande.table === 'a_emporter');
      } else {
        filtered = filtered.filter((commande) => commande.table !== 'a_emporter');
      }
    }
    
    // Trier
    filtered = [...filtered].sort((a, b) => {
      let comparison = 0;
      if (sortBy === 'time') {
        comparison = (b.elapsedTime || 0) - (a.elapsedTime || 0);
      } else if (sortBy === 'table') {
        comparison = String(a.table).localeCompare(String(b.table));
      } else if (sortBy === 'name') {
        comparison = a.prenom.localeCompare(b.prenom);
      }
      return sortOrder === 'asc' ? comparison : -comparison;
    });
    
    return filtered;
  };

  const handleEditOrder = (commande) => {
    setEditingOrder(commande);
    setEditingItems([...commande.items]); // Créer une copie des items pour l'édition
    setIsEditModalOpen(true);
  };

  const handleQuantityChange = (index, newQuantity) => {
    const updatedItems = [...editingItems];
    updatedItems[index] = { ...updatedItems[index], quantity: parseInt(newQuantity) || 0 };
    setEditingItems(updatedItems);
  };

  const handleSaveEdit = async () => {
    try {
      // Vérifier si toutes les quantités sont à 0
      const hasItems = editingItems.some(item => item.quantity > 0);
      
      if (!hasItems) {
        // Si toutes les quantités sont à 0, supprimer la commande
        const commandeRef = doc(db, `clients/${editingOrder.clientId}/commande`, editingOrder.commandeId);
        await deleteDoc(commandeRef);
      } else {
        // Sinon, mettre à jour la commande avec les nouvelles quantités
        const commandeRef = doc(db, `clients/${editingOrder.clientId}/commande`, editingOrder.commandeId);
        await updateDoc(commandeRef, {
          items: editingItems.filter(item => item.quantity > 0) // Ne garder que les items avec une quantité > 0
        });
      }
      setIsEditModalOpen(false);
      showMessage('Commande modifiée avec succès', 'success');
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la commande:", error);
      showMessage('Erreur lors de la modification de la commande', 'error');
    }
  };

  // Ajouter cette fonction pour charger le menu
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const categories = ['entrees', 'plats', 'desserts', 'boissons'];
        let allItems = [];

        for (const category of categories) {
          const productsCollection = collection(db, `menu/${menuId}/${category}`);
          const q = query(productsCollection);
          const querySnapshot = await getDocs(q);
          
          querySnapshot.docs.forEach(doc => {
            allItems.push({
              id: doc.id,
              category: category,
              ...doc.data()
            });
          });
        }

        setMenuItems(allItems);
      } catch (error) {
        console.error("Erreur lors de la récupération du menu:", error);
      }
    };

    fetchMenu();
  }, []);

  // Ajouter cette fonction pour gérer l'ajout d'un item
  const handleAddItem = () => {
    if (selectedItem) {
      const newItem = {
        id: selectedItem.id,
        nom: selectedItem.nom,
        prix: selectedItem.prix,
        quantity: 1
      };
      setEditingItems([...editingItems, newItem]);
      setShowAddItemForm(false);
      setSelectedItem(null);
    }
  };

  const stats = calculateStats();

  if (loading && !user) {
  return (
      <div className="server-orders-loading-container">
        <div className="server-orders-loading-spinner">
          <FaSpinner className="spinning" />
        </div>
        <p className="server-orders-loading-text">Chargement de l'interface serveur...</p>
      </div>
    );
  }

  return (
    <div className="server-orders-container">
      {/* Header */}
      <div className="server-orders-header">
        <div className="server-orders-title-section">
          <FaClipboardList className="server-orders-title-icon" />
          <h1 className="server-orders-title">Interface Serveur</h1>
        </div>
        {serverFirstName && (
          <p className="server-orders-subtitle">
            Bienvenue, {serverFirstName}
          </p>
        )}
      </div>

      {/* Message de feedback */}
      {message && (
        <div className={`server-orders-message server-orders-message-${messageType}`}>
          <div className="server-orders-message-icon">
            {messageType === 'success' && <FaCheckCircle />}
            {messageType === 'error' && <FaExclamationTriangle />}
            {messageType === 'info' && <FaInfoCircle />}
          </div>
          <span>{message}</span>
        </div>
      )}

      {/* Statistiques */}
      {showStats && (
        <div className="server-orders-stats-section">
          <div className="server-orders-stats-grid">
            <div className="server-orders-stat-card">
              <div className="server-orders-stat-icon">
                <FaShoppingCart />
              </div>
              <div className="server-orders-stat-content">
                <div className="server-orders-stat-value">{stats.totalOrders}</div>
                <div className="server-orders-stat-label">Total</div>
              </div>
            </div>
            <div className="server-orders-stat-card">
              <div className="server-orders-stat-icon server-orders-stat-icon-warning">
                <FaClock />
              </div>
              <div className="server-orders-stat-content">
                <div className="server-orders-stat-value">{stats.pendingOrders}</div>
                <div className="server-orders-stat-label">En Attente</div>
              </div>
            </div>
            <div className="server-orders-stat-card">
              <div className="server-orders-stat-icon server-orders-stat-icon-info">
                <FaUtensils />
              </div>
              <div className="server-orders-stat-content">
                <div className="server-orders-stat-value">{stats.inProgressOrders}</div>
                <div className="server-orders-stat-label">En Préparation</div>
              </div>
            </div>
            <div className="server-orders-stat-card">
              <div className="server-orders-stat-icon server-orders-stat-icon-success">
                <FaCheckCircle />
              </div>
              <div className="server-orders-stat-content">
                <div className="server-orders-stat-value">{stats.readyOrders}</div>
                <div className="server-orders-stat-label">Prêtes</div>
              </div>
            </div>
            {stats.urgentOrders > 0 && (
              <div className="server-orders-stat-card server-orders-stat-urgent">
                <div className="server-orders-stat-icon server-orders-stat-icon-danger">
                  <FaBell />
                </div>
                <div className="server-orders-stat-content">
                  <div className="server-orders-stat-value">{stats.urgentOrders}</div>
                  <div className="server-orders-stat-label">Urgentes</div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Contrôles */}
      <div className="server-orders-controls-section">
        <div className="server-orders-search-container">
          <FaSearch className="server-orders-search-icon" />
      <input
            type="text"
            placeholder="Rechercher par ID ou nom client..."
        value={searchId}
        onChange={(e) => setSearchId(e.target.value)}
            className="server-orders-search-input"
          />
        </div>
        
        <div className="server-orders-filters">
          <select
            value={filterTable}
            onChange={(e) => setFilterTable(e.target.value)}
            className="server-orders-filter-select"
          >
            <option value="all">Toutes les tables</option>
            <option value="a_emporter">À emporter</option>
            <option value="salle">En salle</option>
          </select>
          
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="server-orders-filter-select"
          >
            <option value="time">Trier par temps</option>
            <option value="table">Trier par table</option>
            <option value="name">Trier par nom</option>
          </select>
          
          <button
            onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
            className="server-orders-sort-btn"
          >
            {sortOrder === 'asc' ? <FaArrowUp /> : <FaArrowDown />}
          </button>
        </div>
      </div>

      {user ? (
        <div className='server-orders-sections'>
          {/* Commandes initialisées */}
          <div className="server-orders-section">
            <h2 className="server-orders-section-title">
              <FaClock className="server-orders-section-icon" />
              Commandes initialisées
            </h2>
          {initialisedCommandes.length > 0 ? (
              <div className="server-orders-commands-container">
                {filterCommandes(initialisedCommandes).map((commande) => {
                  const isUrgent = commande.elapsedTime >= 10;
                  const totalPrice = commande.items.reduce((acc, item) => acc + item.prix * item.quantity, 0);
                  
                  return (
                    <div 
                      key={commande.commandeId} 
                      className={`server-orders-command-card ${isUrgent ? 'server-orders-urgent' : ''}`}
                    >
                      <div className="server-orders-command-header">
                        <h3 className="server-orders-command-title">
                          <FaTable className="server-orders-command-table-icon" />
                    {commande.table === 'a_emporter' ? 'À Emporter' : `Table n°${commande.table}`} - {commande.idclient}
                  </h3>
                        <div className={`server-orders-command-time ${isUrgent ? 'server-orders-urgent-time' : ''}`}>
                          <FaClock className="server-orders-time-icon" />
                          {commande.elapsedTime} min
                        </div>
                      </div>

                      <div className="server-orders-client-info">
                        <div className="server-orders-client-details">
                          <p className="server-orders-client-name">
                            <FaUser />
                            {commande.prenom}
                          </p>
                          <p className="server-orders-client-id">ID: {commande.idclient}</p>
                        </div>
                      </div>

                      <div className="server-orders-command-items">
                        <h4 className="server-orders-items-title">
                          <FaUtensils className="server-orders-items-icon" />
                          Commandes
                        </h4>
                        <div className="server-orders-items-list">
                          {commande.items.map((item, index) => (
                            <div key={index} className="server-orders-item">
                              <div className="server-orders-item-info">
                                <div className="server-orders-item-name">{item.nom}</div>
                                <div className="server-orders-item-details">
                                  <span className="server-orders-item-quantity">
                                    <FaShoppingCart />
                                    x{item.quantity}
                                  </span>
                                  <span className="server-orders-item-price">
                                    <FaEuroSign />
                                    {item.prix.toFixed(2)} €
                                  </span>
                                </div>
                              </div>
                              <div className="server-orders-item-total">
                                {(item.prix * item.quantity).toFixed(2)} €
                              </div>
                            </div>
                    ))}
                  </div>
                      </div>

                  {commande.commentaire && (
                        <div className="server-orders-comment-section">
                      <button 
                            className="server-orders-comment-btn" 
                        onClick={() => setSelectedComment(commande.commentaire)}
                      >
                            <FaCommentAlt className="server-orders-comment-icon" />
                        Voir le commentaire
                      </button>
                        </div>
                      )}

                      <div className="server-orders-total-section">
                        <div className="server-orders-total-label">
                          <FaEuroSign className="server-orders-total-icon" />
                          Prix total
                          </div>
                        <div className="server-orders-total-amount">
                          {totalPrice.toFixed(2)} €
                        </div>
                    </div>

                      <div className="server-orders-command-actions">
                        <button 
                          className="server-orders-action-btn server-orders-accept-btn" 
                          onClick={() => handleAcceptOrder(commande.clientId, commande.commandeId, commande.prenom, commande.email)}
                        >
                          <FaCheck className="server-orders-action-icon" />
                          Accepter
                        </button>
                </div>
                    </div>
                  );
                })}
            </div>
          ) : (
              <div className="server-orders-no-orders">
                <FaClock className="server-orders-no-orders-icon" />
                <p className="server-orders-no-orders-text">Aucune commande à traiter</p>
              </div>
          )}
          </div>

          {/* Commandes acceptées */}
          <div className="server-orders-section">
            <h2 className="server-orders-section-title">
              <FaUtensils className="server-orders-section-icon" />
              Commandes acceptées & en préparation
            </h2>
          {acceptedCommandes.length > 0 ? (
              <div className="server-orders-commands-container">
              {filterCommandes(acceptedCommandes).map((commande) => {
                // Vérifier si tous les plats et boissons sont prêts
                const isReadyToServe = commande.items.every(
                  (item) =>
                    item.dish_statut === "prepared_dish" ||
                    item.drink_statut === "prepared_drink"
                );
                  const totalPrice = commande.items.reduce((acc, item) => acc + item.prix * item.quantity, 0);

                return (
                    <div key={commande.commandeId} className="server-orders-command-card">
                    {isReadyToServe && (
                        <div className="server-orders-ready-banner">
                          <FaCheckCircle /> Commande prête à être servie
                        </div>
                    )}
                      
                      <div className="server-orders-command-header">
                        <h3 className="server-orders-command-title">
                          <FaTable className="server-orders-command-table-icon" />
                      {commande.table === 'a_emporter' ? 'À Emporter' : `Table n°${commande.table}`} - {commande.idclient}
                    </h3>
                        <div className="server-orders-command-time">
                          <FaClock className="server-orders-time-icon" />
                          {commande.elapsedTime} min
                        </div>
                      </div>

                      <div className="server-orders-client-info">
                        <div className="server-orders-client-details">
                          <p className="server-orders-client-name">
                            <FaUser />
                            {commande.prenom}
                          </p>
                          <p className="server-orders-client-id">ID: {commande.idclient}</p>
                        </div>
                      </div>

                      <div className="server-orders-command-items">
                        <h4 className="server-orders-items-title">
                          <FaUtensils className="server-orders-items-icon" />
                          Commandes
                        </h4>
                        <div className="server-orders-items-list">
                          {commande.items.map((item, index) => (
                            <div key={index} className="server-orders-item">
                              <div className="server-orders-item-info">
                                <div className="server-orders-item-name">
                                  {item.nom}
                                  {item.dish_statut === "prepared_dish" && (
                                    <span className="server-orders-item-status server-orders-status-prepared">
                                      Plat prêt
                                    </span>
                                  )}
                                  {item.drink_statut === "prepared_drink" && (
                                    <span className="server-orders-item-status server-orders-status-prepared">
                                      Boisson prête
                                    </span>
                                  )}
                                </div>
                                <div className="server-orders-item-details">
                                  <span className="server-orders-item-quantity">
                                    <FaShoppingCart />
                                    x{item.quantity}
                                  </span>
                                  <span className="server-orders-item-price">
                                    <FaEuroSign />
                                    {item.prix.toFixed(2)} €
                                  </span>
                                </div>
                              </div>
                              <div className="server-orders-item-total">
                                {(item.prix * item.quantity).toFixed(2)} €
                              </div>
                        </div>
                      ))}
                    </div>
                      </div>

                    {commande.commentaire && (
                        <div className="server-orders-comment-section">
                      <button 
                            className="server-orders-comment-btn" 
                        onClick={() => setSelectedComment(commande.commentaire)}
                      >
                            <FaCommentAlt className="server-orders-comment-icon" />
                        Voir le commentaire
                      </button>
                        </div>
                      )}

                      <div className="server-orders-total-section">
                        <div className="server-orders-total-label">
                          <FaEuroSign className="server-orders-total-icon" />
                          Prix total
                          </div>
                        <div className="server-orders-total-amount">
                          {totalPrice.toFixed(2)} €
                        </div>
                    </div>

                    {commande.serverName && (
                        <div className="server-orders-client-info" style={{ marginBottom: '1rem' }}>
                          <FaUser style={{ color: 'var(--server-orders-success-color)', marginRight: '0.5rem' }} />
                          <span style={{ fontWeight: '600', color: 'var(--server-orders-text-primary)' }}>
                            Commande acceptée par : {commande.serverName}
                          </span>
                        </div>
                      )}

                      <div className="server-orders-command-actions">
                      <button 
                          className="server-orders-action-btn server-orders-edit-btn" 
                        onClick={() => handleEditOrder(commande)}
                      >
                          <FaEdit className="server-orders-action-icon" />
                        Modifier
                      </button>
                      <button 
                          className="server-orders-action-btn server-orders-complete-btn" 
                        onClick={() => handleCompleteOrder(commande.clientId, commande.commandeId, commande.items, commande.prenom, commande.idclient)}
                      >
                          <FaCheck className="server-orders-action-icon" />
                        Terminé
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
              <div className="server-orders-no-orders">
                <FaUtensils className="server-orders-no-orders-icon" />
                <p className="server-orders-no-orders-text">Aucune commande acceptée à traiter</p>
              </div>
          )}
          </div>

          {/* Commandes terminées */}
          <div className="server-orders-section">
            <h2 className="server-orders-section-title">
              <FaCheckCircle className="server-orders-section-icon" />
              Commandes terminées
            </h2>
          {completedCommandes.length > 0 ? (
              <div className="server-orders-commands-container">
                {filterCommandes(completedCommandes).map((commande) => {
                  const totalPrice = commande.items.reduce((acc, item) => acc + item.prix * item.quantity, 0);
                  
                  return (
                    <div key={commande.commandeId} className="server-orders-command-card">
                      <div className="server-orders-command-header">
                        <h3 className="server-orders-command-title">
                          <FaTable className="server-orders-command-table-icon" />
                    {commande.table === 'a_emporter' ? 'À Emporter' : `Table n°${commande.table}`} - {commande.idclient}
                  </h3>
                        <div className="server-orders-command-time">
                          <FaClock className="server-orders-time-icon" />
                          {commande.elapsedTime} min
                        </div>
                      </div>

                      <div className="server-orders-client-info">
                        <div className="server-orders-client-details">
                          <p className="server-orders-client-name">
                            <FaUser />
                            {commande.prenom}
                          </p>
                          <p className="server-orders-client-id">ID: {commande.idclient}</p>
                        </div>
                      </div>

                      <div className="server-orders-command-items">
                        <h4 className="server-orders-items-title">
                          <FaUtensils className="server-orders-items-icon" />
                          Commandes
                        </h4>
                        <div className="server-orders-items-list">
                          {commande.items.map((item, index) => (
                            <div key={index} className="server-orders-item">
                              <div className="server-orders-item-info">
                                <div className="server-orders-item-name">{item.nom}</div>
                                <div className="server-orders-item-details">
                                  <span className="server-orders-item-quantity">
                                    <FaShoppingCart />
                                    x{item.quantity}
                                  </span>
                                  <span className="server-orders-item-price">
                                    <FaEuroSign />
                                    {item.prix.toFixed(2)} €
                                  </span>
                                </div>
                              </div>
                              <div className="server-orders-item-total">
                                {(item.prix * item.quantity).toFixed(2)} €
                              </div>
                            </div>
                    ))}
                  </div>
                      </div>

                  {commande.commentaire && (
                        <div className="server-orders-comment-section">
                      <button 
                            className="server-orders-comment-btn" 
                        onClick={() => setSelectedComment(commande.commentaire)}
                      >
                            <FaCommentAlt className="server-orders-comment-icon" />
                        Voir le commentaire
                      </button>
                        </div>
                      )}

                      <div className="server-orders-total-section">
                        <div className="server-orders-total-label">
                          <FaEuroSign className="server-orders-total-icon" />
                          Prix total
                          </div>
                        <div className="server-orders-total-amount">
                          {totalPrice.toFixed(2)} €
                        </div>
                    </div>

                  {commande.serverName && (
                        <div className="server-orders-client-info" style={{ marginBottom: '1rem' }}>
                          <FaUser style={{ color: 'var(--server-orders-success-color)', marginRight: '0.5rem' }} />
                          <span style={{ fontWeight: '600', color: 'var(--server-orders-text-primary)' }}>
                            Commande acceptée par : {commande.serverName}
                          </span>
                        </div>
                      )}

                      <div className="server-orders-command-actions">
                        <button 
                          className="server-orders-action-btn server-orders-served-btn" 
                          onClick={() => handleServeOrder(commande.clientId, commande.commandeId)}
                        >
                          <FaCheck className="server-orders-action-icon" />
                          Servi
                        </button>
                </div>
                    </div>
                  );
                })}
            </div>
          ) : (
              <div className="server-orders-no-orders">
                <FaCheckCircle className="server-orders-no-orders-icon" />
                <p className="server-orders-no-orders-text">Aucune commande terminée à traiter</p>
              </div>
          )}
          </div>
        </div>
      ) : (
        <p className='commande-loading'>Chargement...</p>
      )}

      {isEditModalOpen && (
        <div className="server-orders-edit-modal">
          <div className="server-orders-edit-modal-content">
            <div className="server-orders-edit-modal-header">
              <FaEdit className="server-orders-edit-modal-icon" />
              <h2 className="server-orders-edit-modal-title">Modifier la commande</h2>
            </div>
            
            {!showAddItemForm ? (
              <>
                <div className="server-orders-edit-items-container">
                  {editingItems.map((item, index) => (
                    <div key={index} className="server-orders-edit-item">
                      <div className="server-orders-edit-item-name">{item.nom}</div>
                      <div className="server-orders-edit-quantity-controls">
                        <button 
                          onClick={() => handleQuantityChange(index, Math.max(0, item.quantity - 1))}
                          className="server-orders-edit-quantity-btn"
                        >
                          <FaMinus />
                        </button>
                        <input
                          type="number"
                          min="0"
                          value={item.quantity}
                          onChange={(e) => handleQuantityChange(index, e.target.value)}
                          className="server-orders-edit-quantity-input"
                        />
                        <button 
                          onClick={() => handleQuantityChange(index, item.quantity + 1)}
                          className="server-orders-edit-quantity-btn"
                        >
                          <FaPlus />
                        </button>
                      </div>
                      <div className="server-orders-edit-item-total">
                        {(item.prix * item.quantity).toFixed(2)} €
                      </div>
                    </div>
                  ))}
                </div>
                
                <button 
                  onClick={() => setShowAddItemForm(true)}
                  className="server-orders-edit-add-item-btn"
                >
                  <FaPlus />
                  Ajouter un plat
                </button>
              </>
            ) : (
              <div className="server-orders-edit-add-item-form">
                <h3>Ajouter un plat</h3>
                <select 
                  value={selectedItem ? selectedItem.id : ''} 
                  onChange={(e) => {
                    const item = menuItems.find(item => item.id === e.target.value);
                    setSelectedItem(item);
                  }}
                  className="server-orders-edit-item-select"
                >
                  <option value="">Sélectionner un plat</option>
                  
                  <optgroup label="Entrées">
                    {menuItems
                      .filter(item => item.category === 'entrees')
                      .map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.nom} - {item.prix.toFixed(2)} €
                          </option>
                        );
                      })}
                  </optgroup>
            
                  <optgroup label="Plats">
                    {menuItems
                      .filter(item => item.category === 'plats')
                      .map(item => (
                        <option key={item.id} value={item.id}>
                          {item.nom} - {item.prix.toFixed(2)} €
                        </option>
                      ))}
                  </optgroup>
            
                  <optgroup label="Desserts">
                    {menuItems
                      .filter(item => item.category === 'desserts')
                      .map(item => (
                        <option key={item.id} value={item.id}>
                          {item.nom} - {item.prix.toFixed(2)} €
                        </option>
                      ))}
                  </optgroup>
            
                  <optgroup label="Boissons">
                    {menuItems
                      .filter(item => item.category === 'boissons')
                      .map(item => (
                        <option key={item.id} value={item.id}>
                          {item.nom} - {item.prix.toFixed(2)} €
                        </option>
                      ))}
                  </optgroup>
                </select>
                
                <div className="server-orders-edit-modal-actions">
                  <button 
                    onClick={handleAddItem}
                    className="server-orders-edit-modal-btn server-orders-edit-modal-save"
                    disabled={!selectedItem}
                  >
                    <FaCheck />
                    Ajouter
                  </button>
                  <button 
                    onClick={() => setShowAddItemForm(false)}
                    className="server-orders-edit-modal-btn server-orders-edit-modal-cancel"
                  >
                    <FaTimes />
                    Annuler
                  </button>
                </div>
              </div>
            )}

            <div className="server-orders-edit-modal-total">
              <span>Total: {editingItems.reduce((acc, item) => acc + item.prix * item.quantity, 0).toFixed(2)} €</span>
            </div>
            
            <div className="server-orders-edit-modal-actions">
              <button 
                onClick={() => setIsEditModalOpen(false)} 
                className="server-orders-edit-modal-btn server-orders-edit-modal-cancel"
              >
                <FaTimes />
                Annuler
              </button>
              <button 
                onClick={handleSaveEdit} 
                className="server-orders-edit-modal-btn server-orders-edit-modal-save"
              >
                <FaCheck />
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal pour afficher le commentaire */}
      {selectedComment && (
        <div className="server-orders-comment-modal">
          <div className="server-orders-comment-modal-content">
            <div className="server-orders-comment-modal-header">
              <FaCommentAlt className="server-orders-comment-modal-icon" />
              <h3 className="server-orders-comment-modal-title">Commentaire du client</h3>
            </div>
            <p className="server-orders-comment-modal-text">{selectedComment}</p>
            <button 
              className="server-orders-comment-modal-close" 
              onClick={() => setSelectedComment(null)}
            >
              <FaTimes style={{ marginRight: '0.5rem' }} />
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServerOrder;